import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/essentials',
    meta: {
        title: 'Access to essentials | Child Poverty',
    },
    title: 'Access to essentials',
    intro: oneLine`<b>148,000</b> children currently live in households experiencing material hardship. By 2028, the 
        Government has committed to reduce this number by <b>80,000</b>.`,
    image: {
        filename: 'Essentials.png',
        alt: '',
    },
    content: [
        oneLine`<p>Experiencing material hardship means being unable to afford six or more items that most people 
            regard as essentials, such as having enough to eat, warm clothes and sturdy shoes.</p>`,
        oneLine`<p><b>65,000</b> children live in households experiencing severe material hardship, which means going without 
            nine or more essentials for a decent standard of living.</p>`,
    ],
};

export default data;
